export default __webpack_public_path__ + "static/media/completeicon.7fe08c61.png";